import React, { Component, Fragment } from 'react'
import inView from 'in-view'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import TripMap from './TripMap'
import TripHeader from './TripHeader'
import Step from '../Step'

class Single extends Component {
  constructor(props) {
    super(props)

    const { step, trip: {acf: {steps}}} = this.props

    this.state = {
      showMap: false,
      currentStep: step,
      totalSteps: steps ? steps.length : 0,
    }

    this.goToStep = this.goToStep.bind(this)
    this.toggleMap = this.toggleMap.bind(this)
    this.closeMap = this.closeMap.bind(this)
  }
  componentDidMount() {
    const $header = document.querySelector('.header')

    inView.threshold(0.1)

    inView('.trip__footer')
      .on('enter', () => {
        $header.classList.add('header--hidden')
      })
      .on('exit', () => {
        $header.classList.remove('header--hidden')
      })
  }
  goToStep(step) {
    const { currentStep } = this.state

    if (currentStep !== step) {
      this.setState({
        currentStep: step
      })
    }
  }
  toggleMap() {
    const { showMap } = this.state

    this.setState({
      showMap: !showMap
    })
  }
  closeMap() {
    this.setState({
      showMap: false
    })
  }
  render() {
    const { history, options, trip, trips, wpforms } = this.props
    const { showMap, currentStep, totalSteps } = this.state

    return (
      <Fragment>
        <TransitionGroup>
          {showMap && (
            <CSSTransition classNames="fade" timeout={700}>
              <TripMap trip={trip} closeMap={this.closeMap} />
            </CSSTransition>
          )}
        </TransitionGroup>
        <div id="trip" className="trip">
          <TripHeader title={trip.title.rendered} toggleMap={this.toggleMap} />
          {trip.acf.steps && (
            <Step
              currentStep={currentStep}
              history={history}
              options={options}
              toggleMap={this.toggleMap}
              totalSteps={totalSteps}
              trips={trips}
              trip={trip}
              wpforms={wpforms}
            />
          )}
        </div>
      </Fragment>
    )
  }
}

export default Single



// WEBPACK FOOTER //
// ./src/components/Trip/Trip.js